import { ThunkDispatch } from 'redux-thunk';
import { useDispatch } from 'react-redux';
import { AnyAction } from 'redux';

import rootReducer from '../store/reducers';

// Type the dispatch function so we can use it with async/await.
type ReduxState = ReturnType<typeof rootReducer>;
type TypedDispatch = ThunkDispatch<ReduxState, any, AnyAction>;
const useTypedDispatch = () => useDispatch<TypedDispatch>();

export default useTypedDispatch;
